import React from 'react'
import {
  Btn,
  Cnpj,
  CustomPanel,
  OperadoresLogisticosDropdown,
  PageHeader,
} from '../../../../../components'
import { withRouter } from 'react-router-dom'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { tableCellCentered } from '../../../../../assets/js/styles'
import { connect } from 'react-redux'
import { showMessageBox } from '../../../../../store/actions/system.actions'
import { errorHandler } from '../../../../../services/util/error.service'
import { saveClientesSemTrecho } from '../../../../../services/api/https/registration/client.http'

const ClientesSemTrecho = ({ history, dispatch }) => {
  // Const
  const { clientesSemTrecho, operationcenter_id } = history.location.state

  // Hooks
  const [isLoading, setIsLoading] = React.useState(false)
  const [clientes, setClientes] = React.useState(clientesSemTrecho)
  //Events
  const onBtnSalvarTrechoClicked = async () => {
    try {
      if (clientes.some(c => !c.tp_id))
        throw new Error('Selecione o Operador Logístico para TODOS os clientes')
      setIsLoading(true)
      const associacoes = clientes.map(c => ({
        client_id: c.id,
        operationcenter_id,
        step: 1,
        tp_id: c.tp_id,
      }))
      await saveClientesSemTrecho(associacoes)
      history.goBack()
    } catch (e) {
      dispatch(showMessageBox(null, errorHandler(e)))
    }
  }

  const onOperadorChange = (tp_id, cliente) => {
    const index = clientes.findIndex(c => c.id === cliente.id)
    if (index !== -1) {
      const _clientes = [...clientes]
      _clientes[index].tp_id = tp_id
      setClientes(_clientes)
    }
  }

  // Render
  return (
    <>
      <div style={{ marginBottom: 15 }}>
        <PageHeader>Clientes Sem Trecho Cadastrado</PageHeader>
      </div>
      <CustomPanel showBtnNovo={false} btnLabel={'Voltar'} onVoltar={history.goBack}>
        <div className="p-grid">
          <div className="p-col-2">
            <Btn onClick={onBtnSalvarTrechoClicked} isLoading={isLoading}>
              SALVAR TRECHOS
            </Btn>
          </div>
        </div>

        <DataTable value={clientes} emptyMessage="Nenhum cliente encontrado">
          <Column field={'nomeFantasia'} header={'Nome Fantasia'} />
          <Column
            header={'CNPJ'}
            body={cliente => <Cnpj>{cliente.cnpj}</Cnpj>}
            style={{ textAlign: 'center' }}
          />
          <Column field={'city'} header={'Cidade'} style={{ textAlign: 'center' }} />
          <Column field={'uf'} header={'UF'} style={tableCellCentered(40)} />
          <Column
            header={'Operador Logístico'}
            body={cliente => (
              <OperadoresLogisticosDropdown
                value={cliente.tp_id ? cliente.tp_id : ''}
                onChange={value => onOperadorChange(value, cliente)}
              />
            )}
            style={tableCellCentered(200)}
          />
        </DataTable>
      </CustomPanel>
    </>
  )
}

export default connect()(withRouter(ClientesSemTrecho))
